import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { SupplierService } from '../../../services/supplier.service';
import { Supplier } from '../../../models/supplier.model';
import { CommonModule } from '@angular/common';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { TableModule } from 'primeng/table';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { debounceTime, distinctUntilChanged, Subject, Subscription } from 'rxjs';
import { PaginatorModule } from 'primeng/paginator';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-list-supplier',
  imports: [
    CommonModule,
    TableModule,
    ButtonModule,
    FormsModule,
    DropdownModule,
    InputTextModule,
    PaginatorModule,
    TooltipModule
  ],
  templateUrl: './list-supplier.component.html'
})
export class ListSupplierComponent implements OnInit {

  private searchSubject = new Subject<string>();
  private searchSubscription?: Subscription;

  status = [
    { label: 'Todos', value: null },
    { label: 'Ativos', value: true },
    { label: 'Inativos', value: false }
  ];

  suppliers: Supplier[] = [];
  searchTerm = '';
  selectedStatus: boolean | null = this.status[0].value;
  loading = true;

  first = 0;
  rows = 10;
  totalRecords = 0;
  currentPage = 1;

  constructor(
    private supplierService: SupplierService,
    public router: Router
  ) {
    this.searchSubscription = this.searchSubject.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(() => this.loadSuppliers());
  }

  ngOnInit(): void {
    this.loadSuppliers();
  }

  onStatusChange(): void {
    this.loadSuppliers();
  }

  onSearchChange(): void {
    this.searchSubject.next(this.searchTerm);
  }

  loadSuppliers(): void {
    this.loading = true;
    this.supplierService.list(this.searchTerm, this.selectedStatus ?? undefined, this.currentPage).subscribe({
      next: (data) => {
        this.suppliers = data.data?.data ?? data.data ?? [];
        this.totalRecords = data.pagination?.totalRecords ?? (data.data as any)?.totalItems ?? 0;
        this.loading = false;
      },
      error: () => {
        this.loading = false;
      }
    });
  }

  onPageChange(event: any): void {
    this.first = event.first;
    this.currentPage = Math.floor(this.first / this.rows) + 1;
    this.loadSuppliers();
  }

  createSupplier(): void {
    this.router.navigate(['/app/suppliers/new']);
  }

  edit(supplier: Supplier): void {
    this.router.navigate(['/app/suppliers/edit', supplier.id]);
  }
}
